import { isValidElement, ReactElement } from 'react';

import { createTranslatedText } from '@dreryk/react-common';
import { TestId } from '@dreryk/react-components';

import { StyledTooltipCell } from './TooltipCell.styled';

type TooltipCellProps = {
   readonly testId: TestId;
   readonly children: string | number | ReactElement | null;
};

export const TooltipCell = (props: TooltipCellProps): JSX.Element => {
   if (!props.children) {
      return <>{'-'}</>;
   }
   return (
      <StyledTooltipCell
         testId={props.testId}
         content={isValidElement(props.children) ? props.children : createTranslatedText(`${props.children}`)}
      >
         <>{props.children}</>
      </StyledTooltipCell>
   );
};
